import { DefaultPageHeader } from 'layouts';
import { AxiosErrorHandler, Card, Col, InfinityLoading, Loading, Row } from 'ui';
import { ContentObjectRenderer } from '../content-object-renderer';
import { CreateJournalNoteTrigger } from '../create-journal-note-trigger';
import { useJournalFeedInfiniteQuery } from '../queries';

const JournalFeed = () => {
  const { data, error, fetchNextPage, hasNextPage, isFetching, isLoading } = useJournalFeedInfiniteQuery({
    limit: 7,
  });

  const items = data?.pages.flat();

  return (
    <>
      <DefaultPageHeader title="Journal" />
      <Row gutter={[0, 'ms']}>
        <Col span={24}>
          <Card marginBottom={false}>
            <CreateJournalNoteTrigger />
          </Card>
        </Col>
        <Col span={24}>
          <AxiosErrorHandler error={error}>
            {isLoading || !items ? (
              <Loading />
            ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- Its okay in this case, we have to check loading, data and emptyState
            items.length === 0 ? null : (
              <Row gutter={[0, 'ms']}>
                {items.map((item) => (
                  <Col key={item.id} span={24}>
                    <Card marginBottom={false}>
                      <ContentObjectRenderer item={item} key={item.id} view="feed" />
                    </Card>
                  </Col>
                ))}
                <Col span={24}>
                  <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
                </Col>
              </Row>
            )}
          </AxiosErrorHandler>
        </Col>
      </Row>
    </>
  );
};

export default JournalFeed;
